.ux-iws-shop-product-search {
    .ux-tab-container__tab-body {
        padding-top: 0;
    }

    .ux-tab .categories {
        border-top: 0;
    }
}
